var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8V32C0.25 36.4187 3.83133 40 8.25 40H32.25C36.6687 40 40.25 36.4187 40.25 32V8C40.25 3.58133 36.6687 0 32.25 0H8.25C3.83133 0 0.25 3.58133 0.25 8ZM32.25 37.3333H8.25C5.30467 37.3333 2.91667 34.9453 2.91667 32V8C2.91667 5.05467 5.30467 2.66667 8.25 2.66667H32.25C35.1953 2.66667 37.5833 5.05467 37.5833 8V32C37.5833 34.9453 35.1953 37.3333 32.25 37.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2518 9.73071C14.5798 9.73071 9.98242 14.328 9.98242 20C9.98242 25.672 14.5798 30.268 20.2518 30.268C25.9238 30.268 30.5211 25.672 30.5211 20C30.5211 14.328 25.9238 9.73071 20.2518 9.73071ZM20.2518 26.6667C16.5691 26.6667 13.5851 23.6814 13.5851 20C13.5851 16.3187 16.5704 13.3347 20.2518 13.3347C23.9331 13.3347 26.9184 16.3174 26.9184 20C26.9184 23.6827 23.9331 26.6667 20.2518 26.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3293 9.32529C33.3293 10.6493 32.2533 11.7253 30.9293 11.7253C29.6053 11.7253 28.5293 10.6493 28.5293 9.32529C28.5293 8.00129 29.604 6.92529 30.9293 6.92529C32.2546 6.92529 33.3293 7.99996 33.3293 9.32529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2518 9.73071C14.5798 9.73071 9.98242 14.328 9.98242 20C9.98242 25.672 14.5798 30.268 20.2518 30.268C25.9238 30.268 30.5211 25.672 30.5211 20C30.5211 14.328 25.9238 9.73071 20.2518 9.73071ZM20.2518 26.6667C16.5691 26.6667 13.5851 23.6814 13.5851 20C13.5851 16.3187 16.5704 13.3347 20.2518 13.3347C23.9331 13.3347 26.9184 16.3174 26.9184 20C26.9184 23.6827 23.9331 26.6667 20.2518 26.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3293 9.32529C33.3293 10.6493 32.2533 11.7253 30.9293 11.7253C29.6053 11.7253 28.5293 10.6493 28.5293 9.32529C28.5293 8.00129 29.604 6.92529 30.9293 6.92529C32.2546 6.92529 33.3293 7.99996 33.3293 9.32529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3293 9.32529C33.3293 10.6493 32.2533 11.7253 30.9293 11.7253C29.6053 11.7253 28.5293 10.6493 28.5293 9.32529C28.5293 8.00129 29.604 6.92529 30.9293 6.92529C32.2546 6.92529 33.3293 7.99996 33.3293 9.32529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2518 9.73071C14.5798 9.73071 9.98242 14.328 9.98242 20C9.98242 25.672 14.5798 30.268 20.2518 30.268C25.9238 30.268 30.5211 25.672 30.5211 20C30.5211 14.328 25.9238 9.73071 20.2518 9.73071ZM20.2518 26.6667C16.5691 26.6667 13.5851 23.6814 13.5851 20C13.5851 16.3187 16.5704 13.3347 20.2518 13.3347C23.9331 13.3347 26.9184 16.3174 26.9184 20C26.9184 23.6827 23.9331 26.6667 20.2518 26.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.b5208740f31ce22534376e00a6f352e0.svg";
export { ForwardRef as ReactComponent };